import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export type FormGridSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface FormGridProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function FormGrid({ className, children, ...props }: FormGridProps) {
  return (
    <div className={cn('form-grid', className)} {...props}>
      {children}
    </div>
  );
}

export interface FormGridColProps extends HTMLAttributes<HTMLDivElement> {
  /** Grid column span (1–12) on the 12-col FormGrid. */
  span?: FormGridSpan;
  /** Full row in flex layout (errors, spinners, `kind="full"`). */
  fullWidth?: boolean;
  children: ReactNode;
}

const spanClassName: Record<FormGridSpan, string> = {
  1: 'col-1',
  2: 'col-2',
  3: 'col-3',
  4: 'col-4',
  5: 'col-5',
  6: 'col-6',
  7: 'col-7',
  8: 'col-8',
  9: 'col-9',
  10: 'col-10',
  11: 'col-11',
  12: 'col-12',
};

export function FormGridCol({
  span = 1,
  fullWidth = false,
  className,
  children,
  style,
  ...props
}: FormGridColProps) {
  const isFullRow = fullWidth || span === 12;

  return (
    <div
      className={cn(
        'form-grid-cell',
        spanClassName[span],
        isFullRow && 'form-grid-cell--full',
        className,
      )}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}
